import { UrlMatchResult, UrlSegment, UrlSegmentGroup } from '@angular/router';

import { AuthRoutes } from '../entities/auth-routes.entity';

function matchesFirstUrlSegment(urlSegments: UrlSegment[], authRoute: AuthRoutes): boolean {
    // we want to strictly check only if one segment is present. we don't want to match on login/redirect.
    return urlSegments.length === 1 ? urlSegments[0].path === authRoute : false;
}

function urlMatcher(url: UrlSegment[], group: UrlSegmentGroup, authRoute: AuthRoutes): UrlMatchResult | undefined {
    const segmentMatches: boolean = matchesFirstUrlSegment(group.segments, authRoute);
    return segmentMatches ? ({ consumed: url } as UrlMatchResult) : undefined;
}

export function LoginRouteMatcher(url: UrlSegment[], group: UrlSegmentGroup): UrlMatchResult | undefined {
    return urlMatcher(url, group, AuthRoutes.Login);
}

export function LogoutRouteMatcher(url: UrlSegment[], group: UrlSegmentGroup): UrlMatchResult | undefined {
    return urlMatcher(url, group, AuthRoutes.Logout);
}
